<template>
  <div class="esp-page-main" :style="{'height': height}">
    <slot></slot>
  </div>
</template>

<script>


export default {
  name: 'EspPageMain',
  data() {
    return {}
  },
  methods: {},
  props: {
    height: {
      type: String,
      default: 'calc(100% - 90px)'
    }
  }
}
</script>

<style scoped>
.esp-page-main {
  background-color: #ffffff;
  /*box-shadow: 0 2px 6px rgba(0, 0, 0, .1);*/
  border-radius: 0px;
  /*margin-top: 15px;*/
  padding: 10px;

}

</style>



// WEBPACK FOOTER //
// src/components/layout/EspPageMain.vue